import { useRef, useState } from 'react';
import { MapContainer, TileLayer, useMapEvent } from 'react-leaflet';
import MapControlls from './MapControlls';
import MapMarker from './MapMarker';

export default function MapSelect({ formik, field, title, height }) {
  const mapRef = useRef(null);
  const [selectedPosition, setSelectedPosition] = useState(field);

  const zoomOfmap = 10;

  function LocationMarker() {
    useMapEvent('click', (event) => {
      mapRef.current.flyTo(event.latlng, 18, {
        animate: true,
        duration: 0.5,
      });
      setSelectedPosition(event.latlng);
      const { lat, lng } = event.latlng;
      formik.setFieldValue('coordinate', [lat, lng]);
    });

    return selectedPosition ? <MapMarker position={selectedPosition} mapRef={mapRef} /> : null;
  }

  return (
    <div className="flex flex-col relative gap-2.5 col-span-full">
      <p className="text-text-normal dark:text-white text-base font-semibold">{title}</p>
      <div
        style={{
          height: `${height}px`,
        }}
        className="h-[500px] rounded-lg relative w-full overflow-hidden z-0"
      >
        <MapControlls mapRef={mapRef} />
        <MapContainer
          ref={mapRef}
          center={selectedPosition || [35.6892, 51.389]}
          zoom={14.5}
          style={{ height: '100%', zIndex: 10 }}
          doubleClickZoom={false}
          dragging={true}
          scrollWheelZoom={true}
          zoomControl={false}
          whenReady={(mapInstance) => {
            mapRef.current = mapInstance.target;
            mapInstance.target.flyTo([35.8, 51.454], zoomOfmap, {
              duration: 1.5,
            });
          }}
        >
          <TileLayer
            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />
          <LocationMarker />
        </MapContainer>
      </div>
    </div>
  );
}
